import {register} from '../vendor/theme-scripts/theme-sections';
import {slider} from '../features/slider';
import {quickAddProduct} from '../features/quick-add';
import {swatchGridSection} from '../features/swatch';
import blockScroll from '../features/block-scroll';

register('list-collections', [slider, quickAddProduct, swatchGridSection, blockScroll]);
